import 'core-js';		        // ECMAScript 5, ECMAScript 6: promises, symbols, collections, iterators, typed arrays, ECMAScript 7+ proposals, setImmediate, etc
import 'custom-event-polyfill';	// for CustomEvent constructor on IE11
import 'raf/polyfill';		    // for requestAnimationFrame

// Note: we might want to specifically pick whats missing instead of
// importing the whole core-js library once the features are completed



// WEBPACK FOOTER //
// ./src/polyfills.tsx